import { loadStripe } from '@stripe/stripe-js';

/**
 * Stripe.js instances keyed by publishable key + connected account (same
 * cache pattern as billing's SetupIntentModal). The SetupIntent lives on the
 * school's Connect account, so Stripe.js MUST be initialized with
 * `stripeAccount` or confirmSetup will 404 the intent.
 */
const stripeCache = new Map();

export const getStripe = (publishableKey, stripeAccount) => {
	const key = `${publishableKey}::${stripeAccount}`;
	if (!stripeCache.has(key)) {
		stripeCache.set(key, loadStripe(publishableKey, { stripeAccount }));
	}
	return stripeCache.get(key);
};
